import React, { useEffect, useState } from 'react';
import Modal from './ui/Modal';
import Btn from './ui/Btn';
import Badge from './ui/Badge';
import { Input } from './ui/Input';
import { propostasApi } from '../api/vendas';
import { COLORS } from '../theme';

function formatarReais(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

const FILTROS_VAZIO = { numero: '', pedido_numero: '', busca: '', valor_min: '', valor_max: '', data_de: '', data_ate: '' };

export default function CopiarPropostaModal({ onSelecionar, onFechar }) {
  const [filtros, setFiltros] = useState(FILTROS_VAZIO);
  const [propostas, setPropostas] = useState([]);
  const [carregando, setCarregando] = useState(false);

  const buscar = () => {
    setCarregando(true);
    const params = {};
    Object.entries(filtros).forEach(([k, v]) => { if (v) params[k] = v; });
    propostasApi.listar(params).then(setPropostas).catch(() => {}).finally(() => setCarregando(false));
  };

  useEffect(() => {
    const t = setTimeout(buscar, 300);
    return () => clearTimeout(t);
  }, [filtros]); // eslint-disable-line

  const onChange = (campo, valor) => setFiltros(f => ({ ...f, [campo]: valor }));

  return (
    <Modal titulo="Copiar Proposta" onFechar={onFechar} largura={780}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginBottom: 10 }}>
        <Input placeholder="Nº da Proposta" type="number" value={filtros.numero} onChange={e => onChange('numero', e.target.value)} />
        <Input placeholder="Nº do Pedido" type="number" value={filtros.pedido_numero} onChange={e => onChange('pedido_numero', e.target.value)} />
        <Input placeholder="Cliente ou Vendedor" value={filtros.busca} onChange={e => onChange('busca', e.target.value)} />
        <Input placeholder="Valor Mínimo R$" type="number" step="0.01" value={filtros.valor_min} onChange={e => onChange('valor_min', e.target.value)} />
        <Input placeholder="Valor Máximo R$" type="number" step="0.01" value={filtros.valor_max} onChange={e => onChange('valor_max', e.target.value)} />
        <div />
        <Input placeholder="Data De" type="date" value={filtros.data_de} onChange={e => onChange('data_de', e.target.value)} />
        <Input placeholder="Data Até" type="date" value={filtros.data_ate} onChange={e => onChange('data_ate', e.target.value)} />
        <Btn variante="ghost" type="button" onClick={() => setFiltros(FILTROS_VAZIO)}>Limpar Filtros</Btn>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 420, overflowY: 'auto' }}>
        {propostas.map(pr => (
          <div key={pr.id} style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            padding: '10px 12px', border: `1px solid ${COLORS.border}`, borderRadius: 8
          }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.text }}>
                Proposta #{pr.numero} {pr.pedido_numero && <span style={{ color: COLORS.textLight, fontWeight: 400 }}>· Pedido #{pr.pedido_numero}</span>}
              </div>
              <div style={{ fontSize: 12, color: COLORS.textMid }}>
                {pr.cliente_nome} · {pr.vendedor_nome} · {new Date(pr.criado_em).toLocaleDateString('pt-BR')} · <Badge tom="info">{formatarReais(pr.valor_total)}</Badge>
              </div>
            </div>
            <Btn tamanho="sm" onClick={() => onSelecionar(pr.id)}>Copiar</Btn>
          </div>
        ))}
        {!carregando && propostas.length === 0 && (
          <p style={{ fontSize: 13, color: COLORS.textMid, textAlign: 'center', padding: 20 }}>Nenhuma proposta encontrada com esses filtros.</p>
        )}
        {carregando && propostas.length === 0 && (
          <p style={{ fontSize: 13, color: COLORS.textMid, textAlign: 'center', padding: 20 }}>Buscando...</p>
        )}
      </div>
    </Modal>
  );
}
